export default __webpack_public_path__ + "static/funnel-significance-dark-73f6fcb30821bc61841e7f1c4d47bb8e.png";